<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.67 2H16.34C19.73 2 22 4.379 22 7.919V16.089C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.089V7.919C2 4.379 4.28 2 7.67 2ZM15.58 15.81C15.83 15.81 16.08 15.68 16.22 15.44C16.44 15.089 16.32 14.629 15.96 14.41L12.4 12.29V7.669C12.4 7.26 12.07 6.919 11.65 6.919C11.24 6.919 10.9 7.26 10.9 7.669V12.72C10.9 12.98 11.04 13.23 11.27 13.36L15.19 15.7C15.31 15.78 15.45 15.81 15.58 15.81Z"
      fill="currentColor" />
  </svg>
</template>
